import { gql, useQuery } from '@apollo/client';

export const CHECK_ACCOUNT_ID_IN_COMMON_CONFIG = gql`
    query CheckAccountIdInCommonConfig($configKey: String!) {
        checkAccountIdInCommonConfig(configKey: $configKey)
    }
`;

interface CheckAccountIdInCommonConfigResponse {
    checkAccountIdInCommonConfig: boolean;
}

export const useCheckAccountIdInCommonConfig = (configKey: string, skip = false) => {
    const { data, loading, error, refetch } = useQuery<CheckAccountIdInCommonConfigResponse>(
        CHECK_ACCOUNT_ID_IN_COMMON_CONFIG,
        {
            variables: { configKey },
            skip,
            fetchPolicy: 'network-only',
        }
    );

    return {
        isEnabled: data?.checkAccountIdInCommonConfig ?? false,
        loading,
        error,
        refetch,
    };
};
